import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc'; // import plugin
import timezone from 'dayjs/plugin/timezone'; // import plugin
import { COUNTRY_TIMEZONE_MAP } from '@cmctechnology/webinvest-constants';

export interface IUseDateDisplayOptions {
  locale?: string;
  weekday?: boolean;
  time?: boolean;
  seconds?: boolean;
  timezone?: boolean;
  defaultResult?: string;
  convertFromSydney?: boolean;
  shortYear?: boolean;
}

const DEFAULT_OPTIONS: IUseDateDisplayOptions = {
  weekday: false,
  time: true,
  seconds: false,
  timezone: true,
  defaultResult: '',
  convertFromSydney: false,
  shortYear: false
};

const SHORT = 'short';
const LONG = 'long';
const FULL = 'full';
const NUMERIC = 'numeric';

const extendDayJs = () => {
  if (!dayjs.utc) {
    dayjs.extend(utc);
  }
  if (!dayjs.tz) {
    dayjs.extend(timezone);
  }
};

export const useDateDisplay = (options?: IUseDateDisplayOptions) => {
  extendDayJs();
  const formatDate = (date?: Date | string | number, formatOptions: IUseDateDisplayOptions | undefined = options): string | undefined => {
    const {
      locale,
      weekday,
      time,
      seconds,
      defaultResult,
      convertFromSydney,
      timezone: showTimezone,
      shortYear
    } = {
      ...DEFAULT_OPTIONS,
      ...options,
      ...formatOptions
    };

    date ??= new Date();

    try {
      const parts = [];
      date = convertFromSydney ? dayjs.tz(date, COUNTRY_TIMEZONE_MAP.AU!).toDate() : dayjs(date).toDate();

      if (weekday) parts.push(date.toLocaleString(locale, { weekday: SHORT }));
      parts.push(
        `${date.getDate()} ${date.toLocaleString(locale, { month: SHORT })}${shortYear ? `, ` + date.getFullYear().toString().slice(2) : ` ` + date.getFullYear()}`
      );
      if (time) {
        parts.push(
          `- ${date.toLocaleString(locale, {
            hour: NUMERIC,
            minute: NUMERIC,
            second: seconds ? NUMERIC : undefined,
            hour12: false
          })}`
        );
      }

      if (showTimezone)
        parts.push(`(${new Intl.DateTimeFormat(locale ?? navigator.language, { dateStyle: FULL, timeStyle: LONG }).format(date).split(' ').pop()})`);

      return parts.join(' ');
    } catch {
      return defaultResult;
    }
  };

  return {
    formatDate
  };
};
